import { ToastMessage } from './toast';

export default function ToastContainer({ messages, onDismiss }) {
  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-end sm:p-6 z-20"
    >
      <div className="flex w-full flex-col items-center space-y-4 sm:items-start">
        {messages.map(({ id, show, message, type }) => (
          <ToastMessage
            key={id}
            id={id}
            message={message}
            show={show}
            onDismiss={onDismiss}
            type={type}
          />
        ))}
      </div>
    </div>
  );
}
